import objectPath from 'object-path';
import * as ActionTypes from '../actions/actionTypes';

export default function reduce(state = {}, action: any) {
    let newState;
    switch (action.type) {
        case ActionTypes.SET_MISSED_OPERATOR_MESSAGES:
            newState = Object.assign({}, state);
            objectPath.set(state, action.payload.stateLocation, action.payload.missedMessages);
            return newState;  
        case ActionTypes.RESTORE_ALME_WINDOW:
            newState = Object.assign({}, state);

            objectPath.set(newState, 'LiveChat.MinimizedCount', 0);

            return newState;  
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./modules/live-chat-foundation-missed-count/reducers/index.ts